import onCalendarIntegrationCreated from './onCalendarIntegrationCreated';
import onCalendarIntegrationDeleted from './onCalendarIntegrationDeleted';
import onCalendarIntegrationUpdated from './onCalendarIntegrationUpdated';

export default {
  onCalendarIntegrationUpdated,
  onCalendarIntegrationDeleted,
  onCalendarIntegrationCreated,
};
